// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmOrder_content__6cTjL {
  width: 100%;
}

.ConfirmOrder_container__NE8zi {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.ConfirmOrder_form__LehFO {
  flex: 3 1;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.ConfirmOrder_form__LehFO h1 {
  font-size: 35px;
}

.ConfirmOrder_form__LehFO h2 {
  margin-bottom: 15px;
  font-size: 20px;
  color: #333;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 5px;
}

.ConfirmOrder_addressCard__a5d1p {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.ConfirmOrder_addressCard__a5d1p p {
  margin: 5px 0;
  font-size: 14px;
  color: #555;
  font-size: 18px;
}

.ConfirmOrder_addressCard__a5d1p strong {
  color: #222;
}

.ConfirmOrder_cartSummary__LQI2p {
  flex: 2 1;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.ConfirmOrder_actions__--k5T {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.ConfirmOrder_backButton__d-4V- {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px 15px;
  cursor: pointer;
  color: #000;
}

.ConfirmOrder_nextButton__ev6eC {
  width: 100%;
  font-weight: bold;
  font-size: 18px;
  background-color: #d9230f;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}

.ConfirmOrder_nextButton__ev6eC:hover {
  background-color: #c9302c;
}

.ConfirmOrder_confirm__2DzB8 {
  padding: 10px;
}

@media (max-width: 768px) {
  .ConfirmOrder_container__NE8zi {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    flex-direction: column;
    width: 100%;
    padding: 10px;
    box-sizing: border-box; /* Previne overflow-ul din cauza padding-ului */
    overflow: hidden;
  }

  .ConfirmOrder_content__6cTjL {
    padding: 10px;
    box-sizing: border-box; /* Previne overflow-ul din cauza padding-ului */
    overflow: hidden;
  }

  .ConfirmOrder_cartSummary__LQI2p {
    flex: 1 1;
    width: 100%;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }

  .ConfirmOrder_content__6cTjL h2 {
    margin: 0;
    padding: 0;
    text-align: left;
  }

  .ConfirmOrder_content__6cTjL h2::after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin: 10px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/ConfirmOrder/ConfirmOrder.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,sBAAsB,EAAE,+CAA+C;IACvE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB,EAAE,+CAA+C;IACvE,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,cAAc;EAChB;AACF","sourcesContent":[".content {\n  width: 100%;\n}\n\n.container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.form {\n  flex: 3;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.form h1 {\n  font-size: 35px;\n}\n\n.form h2 {\n  margin-bottom: 15px;\n  font-size: 20px;\n  color: #333;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 5px;\n}\n\n.addressCard {\n  background-color: #ffffff;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.addressCard p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #555;\n  font-size: 18px;\n}\n\n.addressCard strong {\n  color: #222;\n}\n\n.cartSummary {\n  flex: 2;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 20px;\n}\n\n.backButton {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 8px 15px;\n  cursor: pointer;\n  color: #000;\n}\n\n.nextButton {\n  width: 100%;\n  font-weight: bold;\n  font-size: 18px;\n  background-color: #d9230f;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.nextButton:hover {\n  background-color: #c9302c;\n}\n\n.confirm {\n  padding: 10px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    flex-direction: column;\n    width: 100%;\n    padding: 10px;\n    box-sizing: border-box; /* Previne overflow-ul din cauza padding-ului */\n    overflow: hidden;\n  }\n\n  .content {\n    padding: 10px;\n    box-sizing: border-box; /* Previne overflow-ul din cauza padding-ului */\n    overflow: hidden;\n  }\n\n  .cartSummary {\n    flex: 1;\n    width: 100%;\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .content h2 {\n    margin: 0;\n    padding: 0;\n    text-align: left;\n  }\n\n  .content h2::after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: #ccc;\n    margin: 10px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ConfirmOrder_content__6cTjL`,
	"container": `ConfirmOrder_container__NE8zi`,
	"form": `ConfirmOrder_form__LehFO`,
	"addressCard": `ConfirmOrder_addressCard__a5d1p`,
	"cartSummary": `ConfirmOrder_cartSummary__LQI2p`,
	"actions": `ConfirmOrder_actions__--k5T`,
	"backButton": `ConfirmOrder_backButton__d-4V-`,
	"nextButton": `ConfirmOrder_nextButton__ev6eC`,
	"confirm": `ConfirmOrder_confirm__2DzB8`
};
export default ___CSS_LOADER_EXPORT___;
